import { defineStore } from 'pinia'

export const useCookieConsentStore = defineStore('cookieConsent', () => {
    const { gtag } = useGtag();
    const cartStore = useCartStore();
    const _consent = ref(true);
    const _cookies = ref({
        functional: true,
        analytics: false,
        marketing: false,
    });

    const consent = computed(() => _consent.value);
    const cookies = computed(() => _cookies.value);

    const giveConsent = () => setConsent(true);
    const resetConsent = () => {    
        setCookies({
            functional: true,
            analytics: false,
            marketing: false,
        })
        setConsent(false)
    };

    const setCookies = (value) => _cookies.value = {
        ..._cookies.value,
        ...value
    };

    const setConsent = (consent) => {
        _consent.value = consent;
        if (import.meta.client) {
            const cookie_consent = useCookie('volt_cookie_consent2', {
                maxAge: 31556926, // 1 jaar
                path: '/',
                sameSite: 'lax'
            });

            cookie_consent.value = consent ? btoa(JSON.stringify(_cookies.value)) : null;

            if (_consent.value === true && _cookies.value.analytics) {
                //start gtm
                gtag('consent', 'update', {
                    ad_user_data: 'granted',
                    ad_personalization: 'granted',
                    ad_storage: 'granted',
                    analytics_storage: 'granted',
                })

                //start clarity
                if (window.clarity) {
                    window.clarity('consent', true);
                    if (cartStore.session)
                        window.clarity("set", "session_id", cartStore.session);
                }
            } else {
                //stop gtm
                gtag('consent', 'update', {
                    ad_user_data: 'denied',
                    ad_personalization: 'denied',
                    ad_storage: 'denied',
                    analytics_storage: 'denied',
                })

                //stop clarity
                if (window.clarity) {
                    window.clarity('consent', false);
                }   
            }   

            if (_consent.value === true && _cookies.value.marketing === true) {
                //start fb tracking pixel
            } else {
                //stop fb tracking pixel
            }
        }
    }

    return {
        _consent,
        _cookies,
        consent,
        cookies,
        resetConsent,
        giveConsent,
        setCookies,
    }


});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useCookieConsentStore, import.meta.hot))
}